import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";

export default function PaystackCallbackPage() {
  const [params] = useSearchParams();
  const reference = params.get("reference") || params.get("trxref");
  const [status, setStatus] = useState("verifying");

  useEffect(() => {
    if (!reference) { setStatus("failed"); return; }
    let tries = 0;
    const check = async () => {
      try {
        const { data } = await api.get(`/paystack/verify/${reference}`);
        if (data.status === "success") { setStatus("success"); return; }
      } catch { /* keep polling */ }
      tries += 1;
      if (tries < 5) setTimeout(check, 2500);
      else setStatus("failed");
    };
    check();
  }, [reference]);

  return (
    <div className="mx-auto flex min-h-[60vh] max-w-md flex-col items-center justify-center px-6 text-center" data-testid="paystack-callback-page">
      {status === "verifying" && (
        <>
          <Loader2 className="h-10 w-10 animate-spin text-primary" />
          <h1 className="mt-5 font-display text-2xl">Verifying your payment…</h1>
          <p className="mt-2 text-sm text-muted-foreground">Hold tight — confirming with Paystack.</p>
        </>
      )}
      {status === "success" && (
        <>
          <CheckCircle2 className="h-12 w-12 text-emerald-500" />
          <h1 className="mt-5 font-display text-2xl" data-testid="paystack-success">Payment confirmed! 🎉</h1>
          <p className="mt-2 text-sm text-muted-foreground">Your order is being delivered automatically.</p>
          <Button asChild className="mt-6" data-testid="paystack-go-dashboard">
            <a href="/dashboard">Go to dashboard</a>
          </Button>
        </>
      )}
      {status === "failed" && (
        <>
          <XCircle className="h-12 w-12 text-red-500" />
          <h1 className="mt-5 font-display text-2xl" data-testid="paystack-failed">Payment not confirmed</h1>
          <p className="mt-2 text-sm text-muted-foreground">If you were charged, it will complete automatically within minutes — or contact support.</p>
          <Button asChild variant="outline" className="mt-6">
            <Link to="/pricing">Back to pricing</Link>
          </Button>
        </>
      )}
    </div>
  );
}
